var _this = this,
    _jsxFileName = "/builds/zillow/adtech-product/constellation/zrs-cms-messaging/src/img/TestimonalIcon.jsx";

import React from 'react';
import PropTypes from 'prop-types';

var TestimonialIcon = function TestimonialIcon(_ref) {
  var className = _ref.className;
  return /*#__PURE__*/React.createElement("svg", {
    width: "47",
    height: "44",
    viewBox: "-2 -6 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: className,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 5,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement("title", {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 13,
      columnNumber: 9
    }
  }, "Testimonial Icon"), /*#__PURE__*/React.createElement("path", {
    d: "M3.96003 0H32.9998C35.1868 0 36.9597 1.77294 36.9597 3.95996V19.7998C36.9597 21.9868 35.1868 23.7598 32.9998 23.7598H29.0398V31.6797C29.0377 31.8522 29.0018 32.0226 28.9342 32.1813C28.8002 32.5038 28.5439 32.7601 28.2214 32.8941C27.9019 33.0353 27.5377 33.0353 27.2182 32.8941C27.0562 32.8313 26.9081 32.7371 26.7826 32.6169L17.9387 23.7598H3.96003C1.773 23.7598 6.58035e-05 21.9868 6.58035e-05 19.7998V3.95996C6.58035e-05 1.77294 1.773 0 3.96003 0Z",
    fill: "#006AFF",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 14,
      columnNumber: 9
    }
  }));
};

TestimonialIcon.propTypes = process.env.NODE_ENV !== "production" ? {
  className: PropTypes.string
} : {};
TestimonialIcon.defaultProps = {
  className: null
};
export default TestimonialIcon;